import React from 'react'
import CartIcon from '../../../components/icons/CartIcon'
import { Text } from '../../../modules/Dashboard'
import { ReactComponent as CashVector } from '../assets/CashVector.svg'
import { ReactComponent as PlanVector } from '../assets/PlanVector.svg'

const items = [
    { Icon: CashVector, title: "hint-card-i-1-title", desc: "hint-card-i-1-desc" },
    { Icon: PlanVector, title: "hint-card-i-2-title", desc: "hint-card-i-2-desc" },
]

const HintCard = () => {
    return (
        <div className='space-y-4 w-full bg-gradient-to-br from-[#155DFC] via-[#4F39F6] to-[#9810FA] p-6 rounded-2xl
            transition-all duration-500 ease-out hover:transform hover:-translate-y-1 
            hover:shadow-2xl hover:shadow-[#4F39F6]/40 group relative overflow-hidden'>

            {/* Subtle shine effect */}
            <div className="absolute inset-0 rounded-2xl overflow-hidden opacity-0 group-hover:opacity-100 transition-opacity duration-700 pointer-events-none">
                <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-transparent via-white/10 to-transparent 
                    translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000" />
            </div>

            <span className="flex items-center gap-1 group-hover:translate-x-1 transition-transform duration-300">
                <CartIcon className='group-hover:scale-110 transition-transform duration-500' />
                <Text tid={"invite-friend-hint-card-title"} className='text-lg group-hover:tracking-wide transition-all duration-300' />
            </span>

            <div className='space-y-4'>
                {
                    items.map((i, index) => {
                        const { Icon } = i;
                        return (
                            <div key={index} className='flex items-start justify-start gap-3 w-full p-3 border border-[#05DF724D] 
                                bg-white/10 backdrop-blur-md rounded-xl transition-all duration-400 
                                hover:bg-white/20 hover:border-[#05DF72]/70 hover:transform hover:translate-x-1
                                group-hover:[&:nth-child(1)]:delay-75 group-hover:[&:nth-child(2)]:delay-150'>
                                <Icon
                                    width={48}
                                    height={48}
                                    className='transition-all duration-500 group-hover:scale-110'
                                />
                                <ul className='space-y-1 max-w-md'>
                                    <li>
                                        <Text
                                            tid={i.title}
                                            className='text-lg transition-all duration-300 group-hover:font-medium'
                                        />
                                    </li>
                                    <li>
                                        <Text
                                            tid={i.desc}
                                            className='opacity-90 transition-all duration-300 group-hover:opacity-100'
                                        />
                                    </li>
                                </ul>
                            </div>
                        )
                    })
                }
            </div>

            <div className='w-full p-3 border border-[#05DF724D] bg-gradient-to-r from-[#00C95033] to-[#2B7FFF33] 
                backdrop-blur-md rounded-xl transition-all duration-400
                hover:from-[#00C9504D] hover:to-[#2B7FFF4D] hover:border-[#05DF72]/80
                group-hover:scale-[1.02] group-hover:translate-x-1'>
                <Text
                    tid={"invite-friend-hint-card-footer"}
                    className='transition-all duration-300 group-hover:font-medium'
                />
            </div>
        </div>
    )
}

export default HintCard